"use strict";

exports.__esModule = true;
exports.WatchersSection = WatchersSection;
var _react = _interopRequireDefault(require("react"));
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _excluded = ["watchers", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function WatchersSection(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var watchers = props.watchers,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, _extends({}, extra, {
    heading: translate("TicketDetails.watchers", "Watchers"),
    content: /*#__PURE__*/_react["default"].createElement("p", {
      style: style
    }, watchers.join(", "))
  }));
}